import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'viso-keyboard',
  templateUrl: './keyboard.component.html',
  styleUrls: ['./keyboard.component.scss'],
  standalone: false,
})
export class KeyboardComponent implements OnInit {

  @Input() type: string;
  @Input() value: string;
  @Input() placeholder: string;
  @Input() maxlength: number;
  @Input() isDecimal: boolean;
  @Input() callback: any;
  @Input() previewAvailable: boolean;
  constructor(
    private modalCtl: ModalController,
  ) { }

  ngOnInit() {
    // console.log(this.value);
    this.type = this.type || 'text';
    this.value = this.value || '';
    this.placeholder = this.placeholder || 'Enter your value';
    this.isDecimal = this.isDecimal || false;

    this.value += '';
  }

  typeNumber(number) {
    if (number === '.' && this.value.includes('.')) {
      return;
    }

    if (this.value.length === this.maxlength) {
      
      return;
    }
    this.value += number;
    if (!this.previewAvailable) {
      this.callback(this.value);
    }
  }

  backslash() {
    this.value = this.value.substring(0, this.value.length - 1);
    if (!this.previewAvailable) {
      this.callback(this.value);
    }
  }

  dismiss() {
    this.modalCtl.dismiss(null, 'cancel');
  }

  done() {
    this.modalCtl.dismiss(this.value, 'done');
  }

}
